import React from "react"

import { FieldItems } from "@tenforce/toolbox-field-react"

import { GlobalState } from "../../../../store"
import { useAppSelector } from "../../../../hooks"
import { IActionCard } from "../../../../models/starterpack"
import { ClickableCard } from "../../../common/starterpacks"

export interface Props {
    containerElement: string
    actions: IActionCard[] | null
    isLabelShown: boolean
}

export const ActionList = ({
    containerElement,
    actions,
    isLabelShown,
}: Props): JSX.Element => {
    const { labels } = useAppSelector((state: GlobalState) => state.audits)

    return (
        <>
            {!!actions && actions.length > 0 && (
                <FieldItems
                    data-ft-component={containerElement}
                    data-ft-count={actions.length}
                    label={isLabelShown ? labels.Actions : ""}
                    labelProps={{ extraClasses: "is-dimmed" }}
                    itemsProps={{
                        extraClasses: "tw-flex-col",
                        hasNormalAlignment: true,
                    }}
                >
                    {actions.map((action) => (
                        <ClickableCard
                            key={action.id}
                            element="action"
                            {...action}
                        />
                    ))}
                </FieldItems>
            )}
        </>
    )
}

export default ActionList
